import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';

const isInternal = (href = '') => href.startsWith('/') && !href.startsWith('//');

const components = {
  a: ({ href = '', children, ...rest }) =>
    isInternal(href) ? (
      <Link to={href} {...rest}>{children}</Link>
    ) : (
      <a href={href} target={href.startsWith('mailto:') ? undefined : '_blank'} rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    ),
  table: ({ children }) => <div className="jr-table-wrap"><table>{children}</table></div>,
};

export default function Markdown({ children, className = 'jr-body', testId }) {
  return (
    <div className={className} data-testid={testId}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{children || ''}</ReactMarkdown>
    </div>
  );
}
